'use client'
import { withLayout } from '../../shared/Styles.js'
import * as TabsPrimitive from '../../components/tabs.js'
import { cn } from '../../helpers/index.js'
import type { TabsGroupProps } from './types.js'
import React from 'react'

const TabsGroup = React.forwardRef<HTMLDivElement, TabsGroupProps>(({ data, className, ...rest }, forwardedRef) => {
  const { theme, shape, align, tabs } = data

  return (
    <section ref={forwardedRef} {...rest} className={cn(theme === 'dark' ? 'aiui-dark' : '', className)}>
      <TabsPrimitive.Tabs shape={shape} align={align} defaultValue={tabs[0].tabName}>
        <TabsPrimitive.TabsList className="tabs-list">
          {tabs.map(tab => (
            <TabsPrimitive.TabsTrigger key={tab.tabName} value={tab.tabName} className="tabs-trigger">
              {tab.tabName}
            </TabsPrimitive.TabsTrigger>
          ))}
        </TabsPrimitive.TabsList>
        {tabs.map(tab => (
          <TabsPrimitive.TabsContent key={tab.tabName} value={tab.tabName} className="tabs-content">
            {tab.children(tab.tabContent?.[0])}
          </TabsPrimitive.TabsContent>
        ))}
      </TabsPrimitive.Tabs>
    </section>
  )
})

TabsGroup.displayName = 'TabsGroup'
export default withLayout(TabsGroup)
